export default __webpack_public_path__ + "static/media/me1.0ff0a214.png";